import { DownloadsState } from './models';

export const namespace = 'vtn-redact-state-downloads';

export const defaultState: DownloadsState = {
  batches: [],
  isTrayOpen: false,
};

export interface DownloadsStore {
  [namespace]: DownloadsState;
}
